import { Cards } from "../styledComponents/styledComponents";
import data from "../data/data.js";
import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CardComp({ product, state, setState }) {
  const showToastMessage = () => {
    toast.error("Item já está no carrinho!", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  function handleClick(productId) {
    if (
      state.some((element) => {
        return element.id === productId;
      }) === false
    ) {
      const obj = data.find((element) => {
        return element.id === productId;
      });
      console.log("obj :>> ", obj);

      setState([...state, obj]);
    } else {
      showToastMessage();
    }
  }

  return (
    <>
      <Cards>
        <header>
          <img src={product.img} alt="" />
        </header>
        <h3>{product.name}</h3>
        <span>{product.category}</span>
        <h4>R$ {product.price}</h4>
        <button
          onClick={() => {
            handleClick(product.id);
          }}
        >
          Adicionar
        </button>
      </Cards>
    </>
  );
}

export default CardComp;
